<template>
    <el-card class="page_card account_center" ref="card" v-loading="!is_ok">
        <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick" style="height: 100%;">
            <el-tab-pane label="企业名称统计" name="comName" style="padding: 20px 15px;overflow-y: auto;height: calc(100vh - 110px);position: relative">
                <span style="font-size: 1.2em">企业名称统计</span>
                <el-divider></el-divider>
                <el-form inline :model="selectForm" ref="selectForm">
                     <el-form-item label="企业名称/简称">
                        <el-select
                            v-model="selectForm.comId"
                            :multiple="false"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入企业名称/简称"
                            @change="changeCom">
                            <el-option
                                v-for="item in componys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="selectForm.timeRange"
                            type="daterange"
                            align="right"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
                        <el-button plain @click="resetSelect()">重 置</el-button>
                        <el-button plain type="success" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
                    </el-form-item>
                </el-form>
                <el-table ref="table" :data="list" :max-height="tableMaxHeight" show-summary :summary-method="getSummaries" @sort-change="sortChanges">
                    <el-table-column label="企业名称" width="" align="center">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="取消计划数" sortable="custom" prop="cancel" width="" align="center">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.cancel}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="过期计划数" sortable="custom" prop="expire" width="" align="center">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.expire}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="作废计划数" sortable="custom" prop="reject" width="" align="center">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.reject}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="总数" sortable="custom" prop="totalCount" width="" align="center">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.totalCount}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <div style="height: 50px;display: flex;align-items: center;position: absolute;bottom: 43px;left: 0">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size="15"
                        hide-on-single-page
                        @current-change="pageChange"
                        :total="total">
                    </el-pagination>
                </div> -->
            </el-tab-pane>
            <el-tab-pane label="主车号统计" name="plateNumber" style="padding: 20px 15px;overflow-y: auto;height: calc(100vh - 110px);position: relative">
                <span style="font-size: 1.2em">主车号统计</span>
                <el-divider></el-divider>
                <el-form inline :model="selectFormPlate" ref="selectFormPlate">
                    <el-form-item label="主车号">
                        <el-input placeholder="请输入主车号" v-model="selectFormPlate.plateNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="selectFormPlate.timeRange"
                            type="daterange"
                            align="right"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button plain type="primary" @click="selectSubmitPlate()">查 询</el-button>
                        <el-button plain @click="resetSelectPlate()">重 置</el-button>
                        <el-button plain type="success" @click="exportExcelPlate"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
                    </el-form-item>
                </el-form>
                <el-table ref="table" :data="listPlate" :max-height="tableMaxHeightPlate" @sort-change="sortChange">
                    <el-table-column label="主车号" width="" prop="plateNumber">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.plateNumber}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="取消计划数" width="" sortable="custom" prop="cancel">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.cancel}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="过期计划数" width="" sortable="custom" prop="expire">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.expire}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="作废计划数" width="" sortable="custom" prop="reject">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.reject}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="总数" width="" sortable="custom" prop="totalCount">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.totalCount}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="height: 50px;display: flex;align-items: center;position: absolute;bottom: 43px;left: 0">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size="15"
                        hide-on-single-page
                        @current-change="pageChangePlate"
                        :total="totalPlate">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>
<script>
import request from '@/utils/request'
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'
import dayjs from "dayjs"
export default {
    name:'summary_table',
    data(){
        return{
            is_ok:false,
            activeName:"comName",
            componys:[],
            selectForm:{
                comId:"",
                timeRange:[],
                // pageNum:1,
                // pageSize:15
            },
            tableMaxHeight:0,
            total:0,
            list:[],
            selectFormPlate:{
                plateNumber:"",
                timeRange:[],
                pageNum:1,
                pageSize:15
            },
            tableMaxHeightPlate:0,
            totalPlate:0,
            listPlate:[],
            baseUrl:'',
            listData:{},
            proptype:''
        }
    },
    methods:{
        
        sortChange(column) {
            this.selectFormPlate.pageNum = 1; 
            this.proptype = column.prop; 
            this.listPlate = this.listPlate.sort(
                this.SortFun(column.prop, column.order === "ascending")
            );
            /* if (column.order === "descending") {
                //大到小

                this.tableData = this.tableData.sort(this.SortFun(column.prop, 1)); //从大到小
            } else if (column.order === "ascending") {
                this.tableData = this.tableData.sort(this.SortFun(column.prop, -1)); //从小到大
            } */
        },
        sortChanges(column) {
            this.proptype = column.prop; 
            this.list = this.list.sort(
                this.SortFun(column.prop, column.order === "ascending")
            );
        },
        SortFun(attr, rev) {
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = rev ? 1 : -1;
                //rev = rev>0 ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                return rev * -1;
                }
                if (a > b) {
                return rev * 1;
                }
                return 0;
            };
        },
        handleClick(tag,event){
            if(event.currentTarget.id=="comName"){
                this.getData();
            }else if(event.currentTarget.id=="tab-plateNumber"){
                this.getDataPlate();
            }
        },
        resetSelect(){
            this.selectForm = {
                comId:"",
                timeRange:[],
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        selectSubmit(){
            this.getData();
        },
        resetSelectPlate(){
            this.selectFormPlate = {
                plateNumber:"",
                timeRange:[],
                pageNum:1,
                pageSize:15
            };
            this.$refs["selectFormPlate"].resetFields();
           this.getDataPlate();
        },
        selectSubmitPlate(){
            // console.log("selectFormPlate.timeRange",this.selectFormPlate.timeRange);
            // return
            this.getDataPlate();
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        changeCom(e){
            this.selectForm.id=e;
            this.getData();
        },
        getData(){
            if(this.selectForm.timeRange == null || this.selectForm.timeRange == ''){
                this.selectForm.timeRange = []
            }
            request.post("report/cancel_plan/by_client",this.selectForm).then(res=>{
                this.listData=res.data
                this.list = res.data.webReportCliCancelPlanVOList;
                this.total = res.webReportCliCancelPlanVOList.lenght;
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-145;
            }).catch(err=>{
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-145;
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }else if(index === 1){
                    sums[index] = this.listData.cancelCount;
                    return;
                }else if(index === 2){
                    sums[index] =this.listData.expireCount;
                    return;
                }else if(index === 3){
                    sums[index] =this.listData.rejectCount;
                    return;
                }else if(index === 4){
                    sums[index] =this.listData.totalAllCount;
                    return;
                }
            });
            return sums;
      },
        //分页改变
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        getDataPlate(){
            if(this.selectFormPlate.timeRange == null || this.selectFormPlate.timeRange == ''){
                this.selectFormPlate.timeRange = []
            }
            request.post("report/cancel_plan/by_carno",this.selectFormPlate).then(res=>{
                this.listPlate = res.data.list;
                this.totalPlate = res.data.total;
                this.is_ok = true;
                this.tableMaxHeightPlate = this.$refs.card.$el.offsetHeight - this.$refs.selectFormPlate.$el.offsetHeight-145;
            }).catch(err=>{
                this.is_ok = true;
                this.tableMaxHeightPlate = this.$refs.card.$el.offsetHeight - this.$refs.selectFormPlate.$el.offsetHeight-145;
            });
        },
        pageChangePlate(page){
            this.selectFormPlate.pageNum = page;
            this.getDataPlate();
        },
        //保存到excel文件中
        async exportExcel(){
            try{
                let res = await fetch(this.baseUrl+"/report/cancel_plan/by_client/excel",{
                    method:"POST",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                    body:JSON.stringify(this.selectForm)
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "企业名称统计表.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },
        async exportExcelPlate(){
            try{
                let res = await fetch(this.baseUrl+"/report/cancel_plan/by_carno/excel",{
                    method:"POST",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                    body:JSON.stringify(this.selectFormPlate)
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "主车号统计表.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },
        getNextDate(date,day){
        let dd=new Date(date);
        dd.setDate(dd.getDate()+day);
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        return y+'-'+m+'-'+d;
      }
    },
    created(){
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
    },

    mounted(){
        let dd=new Date();
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 00:00:00`
        let endTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 23:59:59`
        let firstDay = dayjs(dayjs().$d).format('YYYY')
        let endDay = dayjs(dayjs().$d).format('YYYY')
        let startTimeFormPlate=firstDay+'-'+'01-01 00:00:00'
        let endTimeFormPlate=endDay+'-'+'12-31 00:00:00'
        this.selectForm.timeRange.push(startTime,endTime)
        this.selectFormPlate.timeRange.push(startTimeFormPlate,endTimeFormPlate)
        this.getData();
        this.getDataPlate();
        this.getCompany();
    }
}
</script>
<style scoped lang="scss">

</style>
